// TODO: all routes should be pre-fixed with /api/v1
export enum URLPaths {
    test = '/test',
    joinWaitList = '/join-waitlist',
    createNewAccommodationPost = '/accommodations',
    createNewSalePost = '/sale',
    corpMemberSignUp = '/signup',
    corpMemberLogIn = '/login',

    corpMemberGoogleSignUp = '/google/signup',
    corpMemberGoogleLogin = '/google/login',

    verifyEmail = '/verify-email',
    resendVerificationEmail = '/resend-verification-email',
    snoozeVerificationReminder = '/snooze-verification-reminder',

    forgotPassword = '/forgot-password',
    resetPassword = '/reset-password',

    createNewPPA = '/ppa',
    getAllPPAs = '/ppas',
    searchPPAs = '/ppas/search',

    search = '/search',

    getAllItems = '/all-items',

    getAllBookmarkedItems = '/profile/bookmarks',
    getAllPostedItems = '/profile/posts',

    deletePostedItem = '/profile/post',
    /** Undo a delete (any time before it's removed for good, 14 days on). */
    restorePostedItem = '/profile/post/restore',

    createNewPpaReview = '/ppa/review',

    corpMemberProfileUpdate = '/profile',
    corpMemberProfileMe = '/profile/me',
    corpMemberProfileBioUpdate = '/profile/bio',
    corpMemberProfileServiceDetailsUpdate = '/profile/service-details',
    corpMemberProfilePpaDetailsUpdate = '/profile/ppa-details',
    corpMemberProfileOtherDetailsUpdate = '/profile/other-details',
    corpMemberProfilePhotoUpdate = '/profile/profile-photo',

    corpMemberOnboarding = '/profile/onboarding',
    corpMemberOnboardingWishlist = '/profile/onboarding/wishlist',
    corpMemberOnboardingWishlistMatches = '/profile/onboarding/wishlist-matches',
    corpMemberAlerts = '/profile/alerts',
    corpMemberAlert = '/profile/alert',

    getNgStates = '/ng-states',
    getNgStateAndLGAs = '/ng-state-and-lgas',
    getNgStateLGAs = '/ng-states/:state_id/lgas',
    getLgaPpaAutocomplete = '/ppas/lga/:lga_id/autocomplete',

    sayHi = '/hi',

    getAllChats = '/chat',
    getOlderChatMessages = '/chat/:room/messages',
    chatBookmark = '/chat/bookmark/',
    getBookmarkedChatMessages = '/chat/bookmarks',

    saleBookmark = '/sale/bookmark/',
    accommodationBookmarks = '/accommodation/bookmarks',
    accommodationBookmark = '/accommodation/bookmark/',
    /** The ids of the sales you saved. */
    saleBookmarks = '/sale/bookmarks',
    publicStats = '/stats', // public: no login (the home page's "Learn more")
    saleSold = '/sale/:id/sold',
    /** How many people you're chatting with about your sale (for the delete warning). */
    saleConversations = '/sale/:id/conversations',
    /** How many people you're chatting with about your accommodation (for the delete warning). */
    accommodationConversations = '/accommodation/:id/conversations',
    ppaBookmark = '/ppa/bookmark/',
    ppaLike = '/ppa/like/',

    updateRoomReadReceipts = '/chat/mark-read',

    searchCorpMembersForMention = '/corp-members/search',

    getCorpMemberData = '/profile/:id',

    getSaleById = '/sale/:id',
    getAccommodationById = '/accommodation/:id',
    getPpaById = '/ppas/:id',
    getPpaReviews = '/ppas/:id/reviews',

    // Admin
    adminLogin = '/admin/login',
    // Admin (all require x-admin-key header after login)
    adminPostsSale = '/admin/posts/sale',
    adminPostsSaleId = '/admin/posts/sale/:id',
    adminPostsAccommodation = '/admin/posts/accommodation',
    adminPostsAccommodationId = '/admin/posts/accommodation/:id',
    adminChatsNationalMessages = '/admin/chats/national/messages',
    adminChatsNationalMessagesId = '/admin/chats/national/messages/:id',
    adminChatsNationalAnnounce = '/admin/chats/national/announce',
    adminUsers = '/admin/users',
    adminUsersId = '/admin/users/:id',
    adminUsersBlock = '/admin/users/block',
    adminUsersBlockId = '/admin/users/block/:id',
    adminUsersBlocked = '/admin/users/blocked',
    adminUsersDeleted = '/admin/users/deleted',
    adminUsersDeletedId = '/admin/users/deleted/:id',
    adminReferralsLeaderboard = '/admin/referrals/leaderboard',
    adminPpas = '/admin/ppas',
    adminPpasId = '/admin/ppas/:id',
    adminPpasIdRestore = '/admin/ppas/:id/restore',
    adminPpasIdMerge = '/admin/ppas/:id/merge',
    adminPpasIdSimilar = '/admin/ppas/:id/similar',
    adminPpasBlockedNames = '/admin/ppas/blocked-names',
    adminPpasBlockedNamesId = '/admin/ppas/blocked-names/:id',

    vapidPublicKey = '/vapid-public-key',
    savePushSubscription = '/save-push-subscription',
    deletePushSubscription = '/push-subscription',
}
/** Room id of the national (General Chatroom) chat every corp member is in. */
export const NATIONAL_CHAT_ROOM = 'national-chats'

/**
 * Query param on /messages naming the open chat - the URL is the source of truth for it. Holds
 * NATIONAL_CHAT_URL_VALUE or the other participant's (public) slug_id, never a room id: room ids
 * are private identifiers and URLs leak (analytics, Sentry, history, shared screenshots).
 */
export const MESSAGES_CHAT_QUERY_PARAM = 'chat'

/** MESSAGES_CHAT_QUERY_PARAM value for the national chat. slug_ids are random, so can't clash. */
export const NATIONAL_CHAT_URL_VALUE = 'national'

/**
 * The accommodation types a post can have. Wishlist alerts for places pick from the same list,
 * since alert matching and search compare against these values.
 */
/** First and last names: the backend refuses longer (NAME_MAX_LENGTH in corpers.online). */
export const NAME_MAX_LENGTH = 50

export const ACCOMMODATION_TYPES = ['Self contain', 'Flat', '1 bedroom flat', '2 bedroom flat', '3 bedroom flat'] as const
